import React from "react";
import { ChatInput } from "@sumprio/ui";
import "./AppChatInput.scss";

export interface AppChatInputProps extends Omit<
  React.ComponentProps<typeof ChatInput>,
  "placeholder" | "sendButtonLabel" | "width" | "minRows" | "maxRows" | "showAttachmentIcon"
> {
  placeholder?: string;
  sendButtonLabel?: string;
  width?: React.ComponentProps<typeof ChatInput>["width"];
  minRows?: number;
  maxRows?: number;
  showAttachmentIcon?: boolean;
}

const DEFAULT_PLACEHOLDER = "Type your reply here...";
const DEFAULT_SEND_LABEL = "Send";

export default function AppChatInput({
  placeholder = DEFAULT_PLACEHOLDER,
  sendButtonLabel = DEFAULT_SEND_LABEL,
  width = "full",
  minRows = 1,
  maxRows = 4,
  showAttachmentIcon = true,
  className,
  ...rest
}: AppChatInputProps) {
  const mergedClassName = ["app-chat-input", className].filter(Boolean).join(" ");
  return (
    <ChatInput
      className={mergedClassName}
      placeholder={placeholder}
      sendButtonLabel={sendButtonLabel}
      width={width}
      minRows={minRows}
      maxRows={maxRows}
      showAttachmentIcon={showAttachmentIcon}
      {...rest}
    />
  );
}
